// extracted by mini-css-extract-plugin
export default {"slider__image":"slider_slider__image__mtwsV","slider__pagination":"slider_slider__pagination__jqf+P","slider__page":"slider_slider__page__xnv+o"};